import script from "./CreateApiKey.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateApiKey.vue?vue&type=script&setup=true&lang=js"

import "./CreateApiKey.vue?vue&type=style&index=0&id=481a2972&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-481a2972"]])

export default __exports__